import * as React from "react"
import { Typography } from "@mui/material"
import { formatPrice } from "@ui-seeker/utils"


export default function priceColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { currency }) => <Typography variant="body2" sx={{ mr: 2, textAlign: 'right' }}>
				{formatPrice(value, currency)}
			</Typography>
		}
	}
}